import React, { useState } from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Answers } from '../utils/types'
import { modifiedPanasQuestionOptions } from '../utils/constants'
import QuestionCarouselNavigation from '../../../../components/QuestionCarouselNavigation'

interface PartCCarouselProps {
  items: string[]
  answers: Answers
  setAnswers: (answers: Answers) => void
}

const PartCCarousel: React.FC<PartCCarouselProps> = ({
  items,
  answers,
  setAnswers,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const currentItem = items[currentIndex]
  const label = currentItem.substring(0, currentItem.length - 1)
  const currentAnswer = answers[currentItem]

  const handleSelect = (score: number) => {
    const updated = { ...answers, [currentItem]: score }
    setAnswers(updated)
    if (currentIndex < items.length - 1) {
      setCurrentIndex((i) => i + 1)
    }
  }

  const handlePrev = () => {
    setCurrentIndex((i) => Math.max(0, i - 1))
  }

  const handleNext = () => {
    setCurrentIndex((i) => Math.min(items.length - 1, i + 1))
  }

  return (
    <Stack spacing={4}>
      <Box
        borderRadius='lg'
        borderWidth='1px'
        borderColor='purple.100'
        bg='purple.50'
        p={6}
      >
        <VStack spacing={4} align='stretch'>
          <Text fontSize='lg' color='gray.500' textAlign='center'>
            {currentIndex + 1} of {items.length}
          </Text>
          <Heading fontSize='xl' overflowWrap='anywhere' textAlign='center' whiteSpace='normal'>
            {label}
          </Heading>
          <Stack spacing={2}>
            {modifiedPanasQuestionOptions.map((option) => (
              <Button
                key={option.label}
                variant={currentAnswer === option.score ? 'solid' : 'outline'}
                colorScheme='purple'
                height='auto'
                minH='3rem'
                onClick={() => handleSelect(option.score)}
                overflowWrap='anywhere'
                size='lg'
                whiteSpace='normal'
              >
                {option.label}
              </Button>
            ))}
          </Stack>
          <QuestionCarouselNavigation
            isNextDisabled={currentIndex === items.length - 1}
            isPreviousDisabled={currentIndex === 0}
            onNext={handleNext}
            onPrevious={handlePrev}
          />
        </VStack>
      </Box>
    </Stack>
  )
}

export default PartCCarousel
